import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { RedesignFonts, COMIC_BOOK, C } from '../kit';
import { SwampMap } from './Map';
import { 
  M5Header, M5About, M5Takeover, M5Tokenomics, M5Dollarize, 
  M5Roadmap, M5Artist, M5Nfts, M5Memes, M5Comic, M5Join, M5Footer 
} from './Sections';
import { BottomSheet } from './BottomSheet';
import { ComicReader } from '../comic/ComicReader';

const RedesignM5: React.FC = () => {
  const [activeSheet, setActiveSheet] = useState<string | null>(null);
  const [comicOpen, setComicOpen] = useState(false);

  // When a sheet is opened, the user can read the content inside it.
  const renderSheetContent = (id: string | null) => {
    switch(id) {
      case 'about': return <M5About />;
      case 'takeover': return <M5Takeover />;
      case 'tokenomics': return <M5Tokenomics />;
      case 'dollarize': return <M5Dollarize />;
      case 'roadmap': return <M5Roadmap />;
      case 'artist': return <M5Artist />;
      case 'nfts': return <M5Nfts />;
      case 'memes': return <M5Memes />;
      case 'comic': return <M5Comic openComic={() => { setActiveSheet(null); setComicOpen(true); }}/>;
      default: return null;
    }
  };

  const sheetTitle = (id: string | null) => {
    switch(id) {
      case 'about': return 'About Zeus';
      case 'takeover': return 'Community Takeover';
      case 'tokenomics': return 'Tokenomics';
      case 'dollarize': return 'Dollarize';
      case 'roadmap': return 'Roadmap';
      case 'artist': return 'The Artist';
      case 'nfts': return 'NFTs';
      case 'memes': return 'Memes';
      case 'comic': return 'Comic';
      default: return '';
    }
  };

  return (
    <M5Wrapper>
      <RedesignFonts />
      
      {/* 1. Header (Campfire Hero) */}
      <M5Header />

      {/* 2. Swamp Map (Interactive) */}
      <SwampMap onSelect={(id) => setActiveSheet(id)} />

      {/* 3. Read Everything Path (Below map) */}
      <div className="read-everything">
        <M5About />
        <M5Takeover />
        <M5Tokenomics />
        <M5Dollarize />
        <M5Roadmap />
        <M5Artist />
        <M5Nfts />
        <M5Memes />
        <M5Comic openComic={() => setComicOpen(true)} />
        <M5Join />
        <M5Footer />
      </div>

      {/* 4. Bottom Sheet for Map selections */}
      <BottomSheet 
        open={activeSheet !== null} 
        onClose={() => setActiveSheet(null)}
        title={sheetTitle(activeSheet)}
      >
        <SheetWrapper>
          {renderSheetContent(activeSheet)}
        </SheetWrapper>
      </BottomSheet>

      {/* 5. Comic Reader Modal */}
      {comicOpen && (
        <ComicReader 
          pages={COMIC_BOOK} 
          startPage={0} 
          pdf="/zeus.pdf" 
          onClose={() => setComicOpen(false)} 
        />
      )}
    </M5Wrapper>
  );
};

const M5Wrapper = styled.div`
  width: 100%;
  max-width: 430px; /* Mobile width */
  margin: 0 auto;
  background: ${C.ink};
  min-height: 100dvh;
  position: relative;
  overflow-x: hidden;
  font-family: 'Ubuntu', sans-serif;
  
  /* Ensure we handle safe area insets on mobile */
  padding-bottom: env(safe-area-inset-bottom);

  .read-everything {
    display: flex;
    flex-direction: column;
  }
`;

const SheetWrapper = styled.div`
  /* When rendered in the sheet, remove the padding and border that the section normally has */
  > section {
    padding: 0;
    border: none;
    background: transparent !important;
    color: ${C.ink} !important;
  }

  /* Ensure text is dark inside the bottom sheet */
  h1, h2, h3, p, span, div {
    color: ${C.ink};
  }

  /* Reset some specific overrides */
  .hero-img {
    border-color: ${C.ink};
  }
`;

export default RedesignM5;
